// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "bundle" + "." + "4218f7a2a45cd9350998" + ".css";
};